import React from 'react';
import { PartnerAdAudience, PartnerAdPlacement } from '@skyslope/partnerships-sdk';
import { PartnershipsProvider } from '@skyslope/partnerships-sdk/react';
import { useQuery } from '@tanstack/react-query';

import { userManager } from '../../auth';
import useDerivedUserData from '../../hooks/domain/user/useDerivedUserData';

const FormsAdsProvider = ({ children }: { children: React.ReactNode }) => {
  const { regions, userSettings } = useDerivedUserData();
  const isUserLoaded = userSettings != null;

  const { data: token } = useQuery({
    queryKey: ['ads-token'],
    queryFn: () => userManager.getAccessToken(),
    enabled: isUserLoaded,
  });
  const ready = isUserLoaded && token != null;

  return (
    <PartnershipsProvider
      environment={window.environmentKey}
      defaultPlacement={PartnerAdPlacement.FormsGeneral}
      token={token}
      ready={ready}
      loadAdsParams={{
        regions,
        audience: PartnerAdAudience.Agent,
      }}
    >
      {children}
    </PartnershipsProvider>
  );
};

export default FormsAdsProvider;
